import React, { useEffect } from 'react';
import { initMetaPixel, META_PIXEL_ID } from './utils/metaPixel';
import { ProgressBar } from './components/ProgressBar';
import { Hero } from './components/Hero';
import { BuyersLocations } from './components/BuyersLocations';
import { PainPoints } from './components/PainPoints';
import { Product } from './components/Product';
import { Bonuses } from './components/Bonuses';
import { Offer } from './components/Offer';
import { CurrencyNote } from './components/CurrencyNote';
import { Guarantee } from './components/Guarantee';
import { Faq } from './components/Faq';
import { FinalCta } from './components/FinalCta';
import { StickyBar } from './components/StickyBar';
import { PurchaseToast } from './components/PurchaseToast';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="min-h-screen w-full overflow-x-hidden bg-concrete-950 font-sans text-concrete-50 antialiased" data-id="element-0" data-mp="28t4mkhc5agul">
      <ProgressBar data-id="element-1" data-mp="23ut97wmn5o7m" />
      <Hero data-id="element-2" data-mp="23ti8y6semyl9" />
      <main data-id="element-3" data-mp="3ijxo6nd1puib">
        <PainPoints data-id="element-4" data-mp="3ikh8gaq64uzi" />
        <Product data-id="element-5" data-mp="3iiweonbohg2p" />
        <Bonuses data-id="element-6" data-mp="3ijfw82xf22g7" />
        <BuyersLocations data-id="element-7" data-mp="3ihv2ugmu8pjx" />
        <Offer data-id="element-8" data-mp="3mlawr57iwbsx" />
        <CurrencyNote data-id="element-9" data-mp="3ml17jjuay8oa" />
        <Guarantee data-id="element-10" data-mp="3mk852v2dm5by" />
        <Faq data-id="element-11" data-mp="3mjq3rk0ux0x6" />
        <FinalCta data-id="element-12" data-mp="3mj6hjr46bqdc" />
      </main>
      <footer className="bg-concrete-950 px-5 py-10 text-center text-xs text-concrete-400 sm:px-8" data-id="element-13" data-mp="3rbrbcsn2y3gv">
        <p data-id="element-14" data-mp="6hpnd64cbd2">
          Megapack Constructor Elite 360 · Edición México · Todos los derechos
          reservados.
        </p>
      </footer>
      <StickyBar data-id="element-15" data-mp="2zmo5x9jgin2n" />
      <PurchaseToast data-id="element-16" data-mp="2zn6cp03qwjot" />
      <noscript data-id="element-17" data-mp="33mf3bw3ho1g5">
        <img height="1" width="1" alt="" style={{
        display: 'none'
      }} src={`https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1`} data-id="element-18" data-mp="33lwxq8uxsavk" />
      </noscript>
    </div>;
}